export default __webpack_public_path__ + "static/map_with_badge-1fe2abae48cedda94713df68b294530b.webp";